/**
 * @file
 * In-page filtering for job hub leaf pages (specialty + state).
 *
 * Progressive enhancement: the page ships server-rendered job cards; this
 * script reads the full hub job set from drupalSettings.jobHub, renders filter
 * controls, and re-renders the visible cards client-side when the user filters.
 * No server calls, no URL change — the SSR page and its canonical are untouched.
 */
(function (drupalSettings) {
  'use strict';

  var STEP = 6;
  var PAY_BANDS = [1500, 2000, 2500, 3000];

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(v) {
    var n = parseFloat(v);
    return isNaN(n) ? '' : n.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    }
    if (html != null) {
      e.innerHTML = html;
    }
    return e;
  }

  function cardHtml(job) {
    var meta = '';
    if (job.location) {
      meta += '<span class="similar-job-location">' + esc(job.location) + '</span>';
    }
    if (job.pay_min && job.pay_max) {
      meta += '<span class="similar-job-pay">$' + money(job.pay_min) + ' - $' + money(job.pay_max) + '/wk</span>';
    }
    return '<a href="' + esc(job.url) + '" class="similar-job-card">' +
      '<div class="similar-job-card-info"><h3>' + esc(job.specialty) + '</h3>' +
      '<div class="similar-job-meta">' + meta + '</div></div>' +
      '<span class="btn btn-alternate similar-job-cta">View Job</span></a>';
  }

  function uniqueSorted(values) {
    return values.filter(function (v, i, a) { return v && a.indexOf(v) === i; }).sort();
  }

  ready(function () {
    var cfg = drupalSettings && drupalSettings.jobHub;
    if (!cfg || !cfg.jobs || !cfg.jobs.length) {
      return;
    }
    var grid = document.querySelector('[data-job-hub-grid]');
    var bar = document.querySelector('[data-job-hub-filters]');
    var countEl = document.querySelector('[data-job-hub-count]');
    var moreBtn = document.querySelector('[data-job-hub-more]');
    if (!grid || !bar) {
      return;
    }

    var jobs = cfg.jobs;
    var total = jobs.length;

    // Primary filter = the axis the page is NOT already scoped to.
    var isState = cfg.type === 'state';
    var primaryKey = isState ? 'slug' : 'state';
    var primary = el('select', {
      'class': 'form-select job-hub-filter-select',
      'aria-label': isState ? 'Filter by specialty' : 'Filter by state',
    });
    primary.appendChild(el('option', { value: '' }, isState ? 'All specialties' : 'All states'));
    if (isState) {
      var labels = cfg.specialtyLabels || {};
      uniqueSorted(jobs.map(function (j) { return j.slug; })).forEach(function (s) {
        primary.appendChild(el('option', { value: s }, esc(labels[s] || s)));
      });
    } else {
      uniqueSorted(jobs.map(function (j) { return j.state; })).forEach(function (s) {
        primary.appendChild(el('option', { value: s }, esc(s)));
      });
    }

    // Minimum weekly pay (static bands).
    var pay = el('select', { 'class': 'form-select job-hub-filter-select', 'aria-label': 'Minimum weekly pay' });
    pay.appendChild(el('option', { value: '0' }, 'Any pay'));
    PAY_BANDS.forEach(function (b) {
      pay.appendChild(el('option', { value: String(b) }, '$' + b.toLocaleString('en-US') + '+/wk'));
    });

    bar.appendChild(primary);
    bar.appendChild(pay);
    bar.hidden = false;
    if (countEl) {
      countEl.hidden = false;
    }

    var matches = jobs;
    var shownCount = STEP;

    function render() {
      var shown = matches.slice(0, shownCount);
      grid.innerHTML = shown.length
        ? shown.map(cardHtml).join('')
        : '<p class="job-hub-empty">No matching jobs — <a href="/job-seekers">search the full board</a>.</p>';
      if (countEl) {
        countEl.textContent = matches.length
          ? 'Showing ' + shown.length + ' of ' + matches.length + (matches.length === total ? '' : ' matching') + ' jobs'
          : '';
      }
      if (moreBtn) {
        moreBtn.hidden = shown.length >= matches.length;
      }
    }

    function apply() {
      var pv = primary.value;
      var minPay = parseFloat(pay.value) || 0;
      matches = jobs.filter(function (j) {
        if (pv && j[primaryKey] !== pv) {
          return false;
        }
        if (minPay && !(parseFloat(j.pay_max) >= minPay)) {
          return false;
        }
        return true;
      });
      shownCount = STEP;
      render();
    }

    primary.addEventListener('change', apply);
    pay.addEventListener('change', apply);
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        shownCount += STEP;
        render();
      });
    }
    apply();
  });
})(window.drupalSettings);
